import { useState, useMemo } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import { API_URL } from "../../../utils/constant";
import CreatableDropdown from "../pos/creatableDropdown";

const OldSalesBillModelReallocate = ({ show, onClose, heading, initialData }) => {

  /* =====================
     STATE
  ======================*/
  const [selectedOldSerials, setSelectedOldSerials] = useState([]);
  const [newVariants, setNewVariants] = useState([]);

  const [form, setForm] = useState({
    product_type: "AB-OS",
    product_for: "M",
    product_name: "",
    serial_no: "",        // ✅ FIXED
    product_size: [],
    product_color: [],
    product_price: "",
    product_tax: "12"
  });


  /* =====================
     OLD SERIALS
  ======================*/
  const allOldSerials = useMemo(() => {
    if (!initialData?.product_data) return [];

    return initialData.product_data.flatMap(p =>
      p.serial_nos.map(s => ({
        row_key: `${p.product_id}_${s.serial_no}`,
        product_id: p.product_id,
        product_name: p.product_name,
        product_type: p.product_type,     // ✅ ADD
        product_for: p.product_for,       // ✅ ADD
        price: Number(p.price),
        gst: p.gst,
        gst_included: p.gst_included,
        variant_id: s.variant_id,
        serial_no: s.serial_no
      }))
    );
  }, [initialData]);



  /* =====================
     HANDLERS
  ======================*/
  const toggleOldSerial = (serial) => {
    setSelectedOldSerials(prev => {
      const exists = prev.find(s => s.row_key === serial.row_key);
      if (exists) {
        return prev.filter(s => s.row_key !== serial.row_key);
      }
      return [...prev, serial];
    });
    setNewVariants([]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSizeSelect = (v) => {
    setForm(prev => ({ ...prev, product_size: v }));
  };

  const handleColorSelect = (v) => {
    setForm(prev => ({ ...prev, product_color: v }));
  };

  /* =====================
     ADD MANUAL PRODUCT
  ======================*/
  const addManualProduct = () => {
    if (!form.product_name || !form.product_price || !form.serial_no) {
      alert("Product name, serial & price required");
      return;
    }

    if (newVariants.length >= selectedOldSerials.length) {
      alert("Cannot add more products than selected old serials");
      return;
    }

    const item = {
      product_id: `OTHER_${Date.now()}`,
      product_name: form.product_name,
      product_type: form.product_type,   // ✅ ADD
      product_for: form.product_for,     // ✅ ADD
      price: Number(form.product_price),
      gst: form.product_tax,
      gst_included: true,
      serial_no: form.serial_no,
      variant_id: `TMP_${Date.now()}`
    };

    setNewVariants(prev => [...prev, item]);

    setForm(prev => ({
      ...prev,
      serial_no: "",
      product_price: ""
    }));
  };


  /* =====================
     TOTALS
  ======================*/
  const oldTotal = selectedOldSerials.reduce((s, i) => s + i.price, 0);
  const newTotal = newVariants.reduce((s, i) => s + i.price, 0);
  const diff = newTotal - oldTotal;

  /* =====================
     FINAL PRODUCT DATA
  ======================*/
  const buildFinalProductData = () => {
    const remainingOld = allOldSerials.filter(
      o => !selectedOldSerials.some(s => s.row_key === o.row_key)
    );

    const finalItems = [...remainingOld, ...newVariants];

    const grouped = {};


    finalItems.forEach(item => {
      const key = `${item.product_id}_${item.price}_${item.gst}_${item.gst_included}`;

      if (!grouped[key]) {
        grouped[key] = {
          product_id: item.product_id,
          product_name: item.product_name,
          gst: item.gst,
          gst_included: true,
          product_type: item.product_type,   // ✅ ADD
          product_for: item.product_for,
          price: item.price,
          qty: 0,
          amount: 0,
          serial_nos: []
        };
      }

      grouped[key].qty += 1;
      grouped[key].amount += item.price;
      grouped[key].serial_nos.push({
        serial_no: item.serial_no,
        variant_id: item.variant_id
      });
    });

    return Object.values(grouped);
  };


  /* =====================
     CONFIRM
  ======================*/
  const confirmExchange = async () => {
    const company = JSON.parse(localStorage.getItem("company"));
    const companyId = company?.company?.id;

    const payload = {
      sale_bill_id: initialData.id,
      product_data: buildFinalProductData(),
      removed_variants: selectedOldSerials.map(s => ({
        variant_id: s.variant_id,
        serial_no: s.serial_no
      })),
      price_difference: diff
    };

    console.log('payload ', payload);

    try {
      await axios.post(`${API_URL}/pos/relocate/bill/${companyId}`, payload);
      alert("Exchange completed");
      window.location.reload();
      onClose();
    } catch (err) {
      console.error(err);
      alert("Something went wrong");
    }
  };

  /* =====================
     UI
  ======================*/
  return (
    <Modal show={show} onClose={onClose} heading={heading}>

      {/* OLD SERIALS */}
      <h5>Select Old Serials</h5>
      {allOldSerials.map(s => (
        <button
          key={s.row_key}   // ✅ FIXED
          className={`btn me-2 mb-2 ${selectedOldSerials.some(x => x.row_key === s.row_key)
              ? "btn-danger"
              : "btn-outline-secondary"
            }`}
          onClick={() => toggleOldSerial(s)}
        >
          {s.product_name}
          <br />
          <small>{s.serial_no}</small>
        </button>
      ))}


      {selectedOldSerials.length > 0 && (
        <>
          <hr />

          {/* MANUAL FORM */}
          <div className="row">
            <div className="col-md-4 mb-3">
              <label>Product Type</label>
              <select
                name="product_type"
                value={form.product_type}
                onChange={handleChange}
                className="form-control"
              >
                <option value="AB-OS">AB OS</option>
                <option value="AB-SS">AB SS</option>
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label>Product For</label>
              <select
                name="product_for"
                value={form.product_for}
                onChange={handleChange}
                className="form-control"
              >
                <option value="M">Men</option>
                <option value="W">Women</option>
                <option value="K">Kids</option>
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label>Product Name</label>
              <input
                name="product_name"
                value={form.product_name}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="col-md-4 mb-3">
              <label>Article No.</label>
              <input
                name="product_serial"
                value={form.product_serial}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="col-md-4 mb-3">
              <CreatableDropdown
                label="Size"
                value={form.product_size}
                onChange={handleSizeSelect}
              />
            </div>

            <div className="col-md-4 mb-3">
              <CreatableDropdown
                label="Color"
                value={form.product_color}
                onChange={handleColorSelect}
              />
            </div>

            <div className="col-md-4 mb-3">
              <label>Serial Number</label>
              <input
                name="serial_no"
                value={form.serial_no}
                onChange={handleChange}
                className="form-control"
              />
            </div>


            <div className="col-md-4 mb-3">
              <label>Price</label>
              <input
                type="number"
                name="product_price"
                value={form.product_price}
                onChange={handleChange}
                className="form-control"
              />
            </div>

            <div className="col-md-4 mb-3">
              <label>Tax (%)</label>
              <input
                type="number"
                name="product_tax"
                value={form.product_tax}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>

          <button className="btn btn-primary mb-3" onClick={addManualProduct}>
            Add Product
          </button>
        </>
      )}

      {/* NEW PRODUCTS */}
      {newVariants.length > 0 && (
        <>
          <h6>New Products ({newVariants.length}/{selectedOldSerials.length})</h6>
          <table className="table table-bordered">
            <tbody>
              {newVariants.map((v, i) => (
                <tr key={v.variant_id}>
                  <td>{i + 1}</td>
                  <td>{v.product_name}</td>
                  <td>{v.serial_no}</td>
                  <td>₹{v.price}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() =>
                        setNewVariants(prev =>
                          prev.filter(x => x.variant_id !== v.variant_id)
                        )
                      }
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {/* PRICE DIFF */}
      {selectedOldSerials.length > 0 && (
        <>
          {diff > 0 && <div className="alert alert-warning">Add ₹{diff}</div>}
          {diff < 0 && <div className="alert alert-info">Return ₹{Math.abs(diff)}</div>}
        </>
      )}

      {/* ACTIONS */}
      <div className="d-flex justify-content-end gap-2">
        <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        <button
          className="btn btn-success"
          disabled={newVariants.length === 0}
          onClick={confirmExchange}
        >
          Confirm Exchange
        </button>
      </div>

    </Modal>
  );
};

export default OldSalesBillModelReallocate;
